<template>
    <v-card-text>
        <v-container fluid>
            <v-row dense>
                <v-col cols="12" sm="12">

                    <v-row dense>
                        <v-col cols="12">
                            <span color="black" class="headline text-xs-center"
                                v-text="`Datos Condición Particular de Producto`"></span>
                        </v-col>
                    </v-row>

                    <v-row dense>
                        <v-col cols="12" sm="4">
                            <v-text-field label="Producto" color="textbox" v-model="obForm.producto" readonly outlined
                                dense />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-text-field label="Póliza" color="textbox" v-model="obForm.poliza" readonly outlined
                                dense />
                        </v-col>
                        <v-col cols="12" sm="4"/>
                    </v-row>

                    <v-row dense>
                        <v-col cols="12" sm="12">
                            <v-list two-line subheader>
                                <v-subheader inset>Documentos</v-subheader>

                                <v-list-item v-for="item in _.get(listGeneral,'detalleDocumentos',[])" :key="item.title">
                                    <v-list-item-avatar>
                                        <v-icon :class="[item.iconClass]" v-text="item.icon"></v-icon>
                                    </v-list-item-avatar>

                                    <v-list-item-content>
                                        <v-list-item-title v-text="item.title"></v-list-item-title>
                                        <!-- <v-list-item-subtitle v-text="item.subtitle"></v-list-item-subtitle> -->
                                    </v-list-item-content>

                                    <v-list-item-action>
                                        <v-btn icon>
                                            <v-icon color="primary" @click="ver(item)">visibility</v-icon>
                                        </v-btn>
                                    </v-list-item-action>
                                </v-list-item>
                            </v-list>


                        </v-col>
                    </v-row>

                    <v-row dense >
                        <v-col cols="12" sm="12">
                            <modalPdfComponent :mostrar="objPdf.mostrar" :base64="objPdf.base64" :titulo="objPdf.titulo"/>
                        </v-col>
                    </v-row>

                </v-col>
            </v-row>
        </v-container>
    </v-card-text>
</template>

<script>
    export default {
        name: 'windowDatosTasaComponent',
        inject: ['siguiente', 'setData'],
        components:{
            modalPdfComponent: () => import('@/components/utilites/modalComponent.vue')
        },
        props: {
            listGeneral: {
                type: Object,
                default: {}
            },
            obModal: {
                type: Object,
                default: {}
            },
            active: {
                type: Boolean,
                default: false
            }
        },
        data: () => ({
            obForm: {
                busqueda: ''
            },
            objPdf:{
                mostrar: false,
                base64: '',
                titulo: ''
            },
        }),
        created() {
            this.obForm = {
                busqueda: '',
                idProducto: this.obModal.idProducto,
                producto: this.obModal.producto,
                poliza: this.obModal.poliza,
                idCobertura: null
            };
            this.onListar('L');
        },
        watch: {
            active(val) {
                if (val) {
                    this.obForm = {
                        busqueda: '',
                        idProducto: this.obModal.idProducto,
                        producto: this.obModal.producto,
                        poliza: this.obModal.poliza,
                        idCobertura: null
                    }
                    this.onListar('L');
                }
            }
        },
        methods: {
            onListar(ev) {
                if (!_.isUndefined(ev)) {
                    var error = 'E';
                    var o = _.merge({
                            opcion: 'L_DETALLE_CON'
                        },
                        _.pick(this.obForm, ['idProducto'])
                    );

                    this.setData('listGeneral.detalleDocumentos',[],false);
                    axios.post(`${BASE_URI}administrador/condicion-particular/listar`, o)
                        .then((r) => {
                            if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                            if (_.size(_.get(r, ['data', 'data'], [])) == 0) { error = "I"; throw _.get(r, ['data', 'mensaje'], mensajeEstandar.errorPeticion) };
                                var l = [];
                                _.map(_.cloneDeep(r.data.data),(v)=>{
                                    l.push({
                                        title:v.nombreSeccion,
                                        iconClass:'blue white--text',
                                        icon:'description',
                                        pdf:v.pdf
                                    });
                                });
                                this.setData('listGeneral.detalleDocumentos',l,false);
                                this.$forceUpdate();
                        })
                        .catch((e) => {
                            mensajesAlerta(e, error);
                        });
                }
            },
            ver(v){
                this.objPdf.base64 = JSON.parse(JSON.stringify(v.pdf));
                this.objPdf.titulo = v.title;
                this.objPdf.mostrar = true;
            },
            cerrarModalPdf(){
                this.objPdf.mostrar =  false;
                this.objPdf.base64 = '';
            }
        },
        provide(){
            return{
                cerrarModalPdf: this.cerrarModalPdf
            }
        }
    }
</script>